import { Component, OnInit } from '@angular/core';
import { IStepValidation, WizardStep } from '../../WizardStep';
import { ContactCreateMessageStepComponent } from '../contact-create-message-step/contact-create-message-step.component';

@Component({
  selector: 'app-contact-approve-step',
  templateUrl: './contact-approve-step.component.html',
  styleUrls: ['./contact-approve-step.component.scss'],
})
export class ContactApproveStepComponent implements OnInit, WizardStep {
  static STEP_NAME = 'approve-and-email-contacts';

  wizardData: { [p: string]: any };

  messageData: { [key: string]: string };

  constructor() {}

  ngOnInit() {
    if (this.wizardData[ContactCreateMessageStepComponent.STEP_NAME]) {
      this.messageData =
        this.wizardData[ContactCreateMessageStepComponent.STEP_NAME];
    }
  }

  provideData(): any {
    return null;
  }

  async validate(): Promise<IStepValidation> {
    return {
      success: true,
    };
  }

  renderGreeting(): string {
    if (!this.messageData) {
      return '';
    }

    return this.messageData.greeting.replace(
      '{first_name}',
      this.messageData.first_name
    );
  }
}
